import React, { useRef } from "react";

function DrawColor() {
  const canvasRef = useRef(null);

  const startDrawing = (e) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.strokeStyle = "#FF6B6B";
    ctx.lineWidth = 5;
    ctx.lineCap = "round";

    let drawing = true;

    const draw = (e) => {
      if (!drawing) return;
      ctx.lineTo(e.nativeEvent.offsetX, e.nativeEvent.offsetY);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(e.nativeEvent.offsetX, e.nativeEvent.offsetY);
    };

    const stopDrawing = () => {
      drawing = false;
      ctx.beginPath();
      canvas.removeEventListener("mousemove", draw);
      canvas.removeEventListener("mouseup", stopDrawing);
    };

    canvas.addEventListener("mousemove", draw);
    canvas.addEventListener("mouseup", stopDrawing);
  };

  return (
    <div className="text-center p-6">
      <h2 className="text-3xl font-bold mb-4">🎨 Draw & Color</h2>
      <canvas
        ref={canvasRef}
        width={600}
        height={400}
        onMouseDown={startDrawing}
        className="border-4 border-blue-400 rounded-xl"
      />
      <p className="mt-2 text-lg">Click and drag to draw! 🖌</p>
    </div>
  );
}

export default DrawColor;
